import { render, staticRenderFns } from "./StringType.vue?vue&type=template&id=52c8d345&"
import script from "./StringType.vue?vue&type=script&lang=ts&"
export * from "./StringType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports